import './CustomDropDown.scss'

import {Dropdown} from "react-bootstrap";

// Define a generic type with 'value' and 'label' properties
export interface Option {
    value: string;
    label: string;
}

interface CustomDropdownProps<T extends Option> {
    options: T[];
    selectedValue: string | undefined;
    onSelect: (value: string | undefined) => void;
    className?: string | undefined;
    variant?: string | undefined
    type?: string | undefined
}

export const CustomDropdown = <T extends Option>({ options, selectedValue, onSelect, className, variant, type }: CustomDropdownProps<T>) => {
    return (
        <Dropdown className={`${className}`} onSelect={(eventKey) => onSelect(eventKey as any)}>
            <Dropdown.Toggle
                className="d-inline-flex align-items-center justify-content-between "
                variant={variant}
                id="dropdown-basic">
                {selectedValue || type}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {type && <Dropdown.Item key={type} eventKey={""}>
                    {`All`}
                </Dropdown.Item>}
                {options.map((option) => (
                    <Dropdown.Item key={option.value} eventKey={option.value}>
                        {option.label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};